export default {"src":"/_next/static/media/home-classic-solid.60097560.svg","height":24,"width":24};